import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { toast } from 'react-hot-toast';
import { styled } from 'styled-components';
import { Box } from "../../box/src";
import { ButtonClose } from "../../button/src";
import { Card } from "../../card/src";
import { DURATION, TOAST_TYPE } from './constants';
import { useIconStyle } from './hooks/getIconStyle';
import { Icon } from './Icon';
export const Toast = ({ duration = DURATION, id, message, text, type = TOAST_TYPE.BLANK, visible = true, }) => {
    const iconStyle = useIconStyle({ type });
    return (_jsx(StyledCard, { "$DURATION": duration, "$iconStyle": iconStyle, "data-testid": `ds-toast-${type}`, noBorderRadiusOnSmallScreen: true, style: { opacity: visible ? 1 : 0 }, width: { m: 400, s: '100%' }, children: _jsxs(Box, { justifyContent: "space-between", children: [_jsxs(Box, { children: [_jsx(Icon, { iconStyle: iconStyle }), _jsxs(Box, { "aria-live": "polite", display: "block", mt: 2, role: "status", children: [_jsx(Box, { font: "h4-semibold", children: message }), _jsx(Box, { mt: 1, children: text })] })] }), _jsx(Box, { display: "block", ml: 2, children: _jsx(ButtonClose, { onClick: () => toast.dismiss(id), screenReadersText: undefined, variant: "inversed" }) })] }) }));
};
const StyledCard = styled(Card).attrs(() => ({
    pl: 5,
    pr: 5,
    pt: 5,
})) `
  position: relative;
  overflow: hidden;

  &:hover {
    &:before {
      animation-play-state: paused;
    }
  }

  &:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 4px;
    width: 0%;
    background: ${({ $iconStyle }) => $iconStyle.color};

    animation: ${({ $DURATION }) => `progress ${$DURATION.toString()}ms linear`};
    animation-fill-mode: forwards;
    animation-play-state: running;

    @keyframes progress {
      from {
        width: 0%;
      }
      to {
        width: 100%;
      }
    }
  }
`;
//# sourceMappingURL=Toast.js.map